<div class="configuration-main ui-dark-background" data-cy="procedures-container">
  <mat-card appearance="outlined" style="display: none;"></mat-card>
  <mat-progress-spinner
    style="margin-left: auto; margin-right: auto; position: relative; top: 50%; transform: translateY(-50%)"
    diameter="100" mode="indeterminate" *ngIf="isLoading === true"
    data-cy="procedures-loading-spinner">
  </mat-progress-spinner>

  <div *ngIf="!isLoading" class="configuration-content" data-cy="procedures-content">
    <div class="configuration-left" data-cy="procedures-left-panel">
      <div style="display: flex;" data-cy="procedures-header">
        <div style="flex-basis: fit-content;" class="configuration-section-title" data-cy="procedures-title">Procedures</div>
        <div style="flex: 1;"></div>
        <div *ngIf="isShiftPressed"
          style="cursor: pointer; color: var(--tdo-secondary); margin-top: 8px; margin-right: 8px;"
          (click)="checkProcedureFormsIntegrity()"
          data-cy="procedures-check-integrity">
          <mat-icon>checklist_rtl</mat-icon>
        </div>
      </div>

      <div style="height: calc(100%); max-height: calc(100% - 20px); overflow-y: hidden;" data-cy="procedures-table-container">
        <tdo-table #procedureTable [searchPredicate]="searchPredicate" (rowSelected)="onProcedureRowSelected($event)"
          [dataSource]="procedures" [isUsePaginator]="true" [pageSizeOptions]="[25, 50, 75, 100]" sortActive="name"
          sortDirection="asc" data-cy="procedures-table">
          <tdo-table-column [isSortable]="true" displayName="Name" propertyName="name" [rowTemplate]="nameTemplate" data-cy="procedures-name-column">
            <ng-template #nameTemplate let-row>
              <div style="display: flex;" data-cy="procedures-row-{{row.model.id}}">
                <div (click)="row.model.isExpanded = true;" style="flex-basis: 30px; position: relative; top: 2px;"
                  *ngIf="
                    row.model.childProcedures &&
                    row.model.childProcedures.length > 0 &&
                    !row.model.isExpanded
                  "
                  data-cy="procedures-expand-button-{{row.model.id}}">
                  <mat-icon>expand_more</mat-icon>
                </div>
                <div (click)="row.model.isExpanded = false;" style="flex-basis: 30px; position: relative; top: 2px;"
                  *ngIf="
                    row.model.childProcedures &&
                    row.model.childProcedures.length > 0 &&
                    row.model.isExpanded
                  "
                  data-cy="procedures-collapse-button-{{row.model.id}}">
                  <mat-icon>expand_less</mat-icon>
                </div>

                <div cdkDropListGroup style="flex: 1; margin-bottom: 4px;" data-cy="procedures-drop-group-{{row.model.id}}">
                  <div style="margin-bottom: 4px; position: relative; top: 4px;" data-cy="procedures-name-text-{{row.model.id}}">
                    {{ row.model.name }}
                  </div>

                  <ng-container *ngIf="
                      row.model.isExpanded &&
                      row.model.childProcedures &&
                      row.model.childProcedures.length > 0
                    ">
                    <div cdkDropList cdkDropListOrientation="vertical" (cdkDropListDropped)="drop($event, row.model)" data-cy="procedures-children-list-{{row.model.id}}">
                      <div cdkDrag class="child-procedure" *ngFor="let child of row.model.childProcedures" data-cy="procedures-child-{{child.id}}">
                        <div (click)="onChildProcedureSelected(child)" style="display: flex; cursor: pointer;" data-cy="procedures-child-row-{{child.id}}">
                          <div style="flex: 1; margin-left: 10px;" data-cy="procedures-child-name-{{child.id}}">{{ child.name }}</div>
                          <div [matTooltip]="'Delete ' + child.name + '?'" (click)="deleteProcedure(child)"
                            style="cursor: pointer; color: var(--tdo-secondary-accent);" data-cy="procedures-child-delete-{{child.id}}">
                            <mat-icon>delete</mat-icon>
                          </div>
                        </div>
                      </div>
                    </div>

                  </ng-container>
                </div>
              </div>
            </ng-template>
          </tdo-table-column>

          <tdo-table-column propertyName="Code" targetObjectName="adaCodes" [displayName]="''" data-cy="procedures-code-column">
          </tdo-table-column>

          <tdo-table-column displayName="" propertyName="rowTemplate" [rowTemplate]="deleteTemplate" data-cy="procedures-delete-column">
            <ng-template #deleteTemplate let-row>
              <div [matTooltip]="'Delete ' + row.model.name + '?'" (click)="deleteProcedure(row.model)"
                style="height: 20px; position: relative; top: 0; cursor: pointer; color: var(--tdo-secondary);" data-cy="procedures-delete-button-{{row.model.id}}">
                <mat-icon>delete</mat-icon>
              </div>
            </ng-template>
          </tdo-table-column>
        </tdo-table>
      </div>
    </div>

    <div class="configuration-right" style="display: flex; flex-direction: column;" data-cy="procedures-right-panel">
      <span class="configuration-section-title" data-cy="procedures-info-title">Procedure Info</span>

      <app-tdo-configuration-action-bar [isCustom]="true" data-cy="procedures-action-bar">
        <button mat-button class="tdo-button tdo-save" (click)="create()" data-cy="procedures-new-button">
          New
          <mat-icon>add_circle_outline</mat-icon>
        </button>
        <button [disabled]="
            selectedProcedure?.ParentCaseProcedureId !== null &&
            selectedProcedure?.ParentCaseProcedureId !== '00000000-0000-0000-0000-000000000000'
          " mat-button class="tdo-button tdo-save" (click)="createChildProcedure()" data-cy="procedures-add-sub-button">
          Add Sub
        </button>
        <button mat-button class="tdo-button tdo-save" (click)="save()" data-cy="procedures-save-button">Save</button>
      </app-tdo-configuration-action-bar>
      <br />

      <div style="display: flex; flex-basis: 270px;" *ngIf="selectedProcedure" data-cy="procedures-form">
        <div style="flex: 1;" data-cy="procedures-details">
          <div class="form-group row" data-cy="procedures-name-field">
            <label class="col-2 col-form-label" data-cy="procedures-name-label">Name</label>
            <div class="col-10">
              <input class="form-control" [value]="selectedProcedure.name"
                (input)="selectedProcedure.name = $event.target.value; configurationService.setDirty();" data-cy="procedures-name-input"/>
            </div>
          </div>

          <div style="display: flex; margin-bottom: 16px;" data-cy="procedures-code-field">
            <label class="col-2 col-form-label" data-cy="procedures-code-label">Code</label>
            <div style="flex: 1; margin-left: 4px; display: flex;" data-cy="procedures-code-container">
              <div class="form-control" style="display: flex; overflow-x: auto; overflow-y: hidden;" data-cy="procedures-code-values">
                <div *ngFor="let ada of selectedProcedure.adaCodes" style="
                    display: flex;
                    height: 30px;
                    flex-basis: fit-content;
                    padding: 2px 4px 1px 4px;
                    background-color: var(--tdo-primary);
                    color: white;
                    border-radius: 6px;
                    position: relative;
                    top: -3px;
                    margin-right: 2px;
                  " data-cy="procedures-code-tag-{{ada.Code}}">
                  <div style="flex-basis: fit-content; user-select: none;" data-cy="procedures-code-text-{{ada.Code}}">
                    {{ ada.Code }}
                  </div>
                  <div style="flex-basis: fit-content; color: var(--tdo-primary-accent); cursor: pointer;"
                    [matTooltip]="'Delete ' + ada.Code + ' ?'" (click)="deleteAdaCode(ada)" data-cy="procedures-code-delete-{{ada.Code}}">
                    <mat-icon>delete</mat-icon>
                  </div>
                </div>
              </div>
            </div>
            <div style="flex-basis: 10px;"></div>
            <div
              style="flex-basis: 90px; display: flex; border: 1px solid var(--tdo-primary-accent); border-radius: 4px;" data-cy="procedures-code-add-container">
              <div style="height: 30px; overflow: hidden; padding: 0 6px 0 6px;" data-cy="procedures-code-add-input-container">
                <tdo-input type="text" widthString="100%" style="position: relative; top: -3px;"
                  (inputFinished)="codeInput = $event" data-cy="procedures-code-add-input"></tdo-input>
              </div>
              <div style="color: var(--tdo-primary-accent); margin-top: 6px; cursor: pointer;"
                matTooltip="Add code for procedure"
                (click)="addAdaCode(selectedProcedure.id, codeInput); configurationService.setDirty();" data-cy="procedures-code-add-button">
                <mat-icon>add_circle_outline</mat-icon>
              </div>
            </div>
          </div>

          <div class="form-group row" data-cy="procedures-description-field">
            <label class="col-2 col-form-label" data-cy="procedures-description-label">Description</label>
            <div class="col-10">
              <textarea class="form-control" rows="2" style="resize: none;" [value]="selectedProcedure.description"
                (input)="selectedProcedure.description = $event.target.value; configurationService.setDirty();" data-cy="procedures-description-input"></textarea>
            </div>
          </div>

          <div style="display: flex;" data-cy="procedures-specialty-category-row">
            <app-tdo-dropdown style="flex: 1; margin-right: 10px;" placeholder="Specialty"  tdolabel="Specialty" [isObjectValue]="true"
              [value]="getSpecialtyById(selectedProcedure.enumMedicalSpecialtyID)"
              (selectionChange)="selectedProcedure.enumMedicalSpecialtyID = $event.value.ValidValueItemId; configurationService.setDirty();"
              [dataSource]="procedureMedicalSpecialtiesEnums"
              dataSourceDisplayKey="ItemDisplayValue" data-cy="procedures-specialty-dropdown"></app-tdo-dropdown>

            <app-tdo-dropdown style="flex: 1; margin-left: 10px;" placeholder="Category" tdolabel="Category" [isObjectValue]="true"
              [value]="getCategoryByItemId(selectedProcedure.enumProcedureCategoryID)"
              (selectionChange)="selectedProcedure.enumProcedureCategoryID = $event.value.ValidValueItemId; configurationService.setDirty();"
              [dataSource]="procedureCategoriesEnums" dataSourceDisplayKey="ItemDisplayValue" data-cy="procedures-category-dropdown"></app-tdo-dropdown>
          </div>

          <div style="display: flex;" data-cy="procedures-type-action-row">
            <app-tdo-dropdown style="flex: 1; margin-right: 10px;" placeholder="Type"  tdolabel="Type"   [isObjectValue]="true"
              [value]="getTypeItemByItemId(selectedProcedure.enumProcedureTypeID)"
              (selectionChange)="selectedProcedure.enumProcedureTypeID = $event.value.ValidValueItemId; configurationService.setDirty();"
              [dataSource]="procedureTypeEnums" dataSourceDisplayKey="ItemDisplayValue" data-cy="procedures-type-dropdown"></app-tdo-dropdown>

            <app-tdo-dropdown style="flex: 1; margin-left: 10px;" placeholder="Action Category" tdolabel="Action Category" [isObjectValue]="true"
              [value]="getActionItemByItemId(selectedProcedure.enumProcedureActionCategoryID)"
              (selectionChange)="selectedProcedure.enumProcedureActionCategoryID = $event.value.ValidValueItemId; configurationService.setDirty();"
              [dataSource]="procedureActionCategoriesEnums" dataSourceDisplayKey="ItemDisplayValue" data-cy="procedures-action-category-dropdown"></app-tdo-dropdown>
          </div>
        </div>

        <div style="flex-basis: 200px; margin-left: 20px;" *ngIf="
            !selectedProcedure.ParentCaseProcedureId ||
            selectedProcedure.ParentCaseProcedureId === '00000000-0000-0000-0000-000000000000'
          " data-cy="procedures-groups-panel">
          <app-content-area label="Groups" style="height: 200px; width: 100%;" data-cy="procedures-groups-area">
            <div style="width: 100%; height: 100%; display: flex;" data-cy="procedures-groups-container">
              <div style="flex: 1;" data-cy="procedures-groups-checkboxes">
                <mat-checkbox [checked]="selectedProcedure.partOfAppointmentGroup"
                  (change)="selectedProcedure.partOfAppointmentGroup = $event.checked; configurationService.setDirty();" data-cy="procedures-appointments-checkbox">
                  Appointments
                </mat-checkbox>
                <br />
                <mat-checkbox [checked]="selectedProcedure.partOfVisitGroup"
                  (change)="selectedProcedure.partOfVisitGroup = $event.checked; configurationService.setDirty();" data-cy="procedures-visit-checkbox">
                  Reason for Visit
                </mat-checkbox>
              </div>
            </div>
          </app-content-area>
          <mat-checkbox [checked]="selectedProcedure.isDoNotDeploy"
            (change)="selectedProcedure.isDoNotDeploy = $event.checked" data-cy="procedures-deploy-checkbox">
            Do not deploy
          </mat-checkbox>
        </div>
      </div>

      <div *ngIf="selectedProcedure?.childProcedures?.length === 0"
        style="height: calc(100%); max-height: calc(100% - 20px); overflow-y: hidden; overflow-x: hidden;" class="procedure-forms-list" data-cy="procedures-forms-container">
        <tdo-table *ngIf="this.selectedProcedure" #formsTable label="Forms" [isAddButtonEnabled]="true"
          [isDragAndDropHiddenXOverflow]="true" [isSelectable]="false" [isSearchable]="false"
          [dataSource]="this.selectedProcedure?.forms" (rowSelected)="onZTdoTableRowSelected($event)"
          (addClicked)="addForm()" (rowsReordered)="onFormsReordered()" data-cy="procedures-forms-table">
          <tdo-table-column displayName="Order" propertyName="formOrder" [rowTemplate]="formOrderTemplate" data-cy="procedures-forms-order-column">
            <ng-template #formOrderTemplate let-row>
              <div style="display: flex; align-items: center; justify-content: center;" data-cy="procedures-forms-order-cell-{{row.model.id}}">
                <button mat-icon-button (click)="changeFormOrder(row.model, -1)" [disabled]="row.model.formOrder === 1" data-cy="procedures-forms-order-up-{{row.model.id}}">
                  <mat-icon>arrow_upward</mat-icon>
                </button>

                <span style="margin: 0 8px; font-weight: bold;" data-cy="procedures-forms-order-value-{{row.model.id}}">
                  {{ row.model.formOrder }}
                </span>

                <button mat-icon-button (click)="changeFormOrder(row.model, 1)"
                  [disabled]="row.model.formOrder === selectedProcedure.forms.length" data-cy="procedures-forms-order-down-{{row.model.id}}">
                  <mat-icon>arrow_downward</mat-icon>
                </button>
              </div>
            </ng-template>
          </tdo-table-column>

          <tdo-table-column displayName="Name" propertyName="name" [rowTemplate]="name" data-cy="procedures-forms-name-column">
            <ng-template #name let-row>
              <div style="flex: 1;" data-cy="procedures-forms-name-{{row.model.id}}">{{ row.model.name }}</div>
            </ng-template>
          </tdo-table-column>

          <tdo-table-column displayName="Require Signature" propertyName="isRequireSignature"
            [rowTemplate]="isRequireSignature" data-cy="procedures-forms-signature-column">
            <ng-template #isRequireSignature let-row>
              <div data-cy="procedures-forms-signature-cell-{{row.model.id}}">
                <mat-checkbox style="position: relative; top: 5px;" [(ngModel)]="row.model.isRequireSignature"
                  (change)="configurationService.setDirty();" data-cy="procedures-forms-signature-checkbox-{{row.model.id}}"></mat-checkbox>
              </div>
            </ng-template>
          </tdo-table-column>

          <tdo-table-column displayName="Require Submission" propertyName="isSubmissionRequired"
            [rowTemplate]="isSubmissionRequired" data-cy="procedures-forms-submission-column">
            <ng-template #isSubmissionRequired let-row>
              <div data-cy="procedures-forms-submission-cell-{{row.model.id}}">
                <mat-checkbox style="position: relative; top: 5px;" [(ngModel)]="row.model.isSubmissionRequired"
                  (change)="configurationService.setDirty();" data-cy="procedures-forms-submission-checkbox-{{row.model.id}}"></mat-checkbox>
              </div>
            </ng-template>
          </tdo-table-column>

          <tdo-table-column displayName="Add by Default" propertyName="isAddByDefault" [rowTemplate]="isAddByDefault" data-cy="procedures-forms-default-column">
            <ng-template #isAddByDefault let-row>
              <div data-cy="procedures-forms-default-cell-{{row.model.id}}">
                <mat-checkbox style="position: relative; top: 5px;" [(ngModel)]="row.model.isAddByDefault"
                  (change)="configurationService.setDirty();" data-cy="procedures-forms-default-checkbox-{{row.model.id}}"></mat-checkbox>
              </div>
            </ng-template>
          </tdo-table-column>

          <tdo-table-column displayName="Require Tooth" propertyName="isToothRequired" [rowTemplate]="isToothRequired" data-cy="procedures-forms-tooth-column">
            <ng-template #isToothRequired let-row>
              <div style="padding-left: 20px; width: 100px;" data-cy="procedures-forms-tooth-cell-{{row.model.id}}">
                <mat-checkbox style="position: relative; top: 5px;" [(ngModel)]="row.model.isToothRequired" data-cy="procedures-forms-tooth-checkbox-{{row.model.id}}">
                </mat-checkbox>
              </div>
            </ng-template>
          </tdo-table-column>

          <tdo-table-column displayName="Filled by" propertyName="filledBy" [rowTemplate]="filledBy" data-cy="procedures-forms-filledby-column">
            <ng-template #filledBy let-row>
              <div style="width: 220px;" data-cy="procedures-forms-filledby-cell-{{row.model.id}}">
                <app-tdo-enum-select name="enumFormFilledBy" [validValueItemId]="row.model.filledBy"
                  (enumSelected)="onFilledBySelection($event, row)" data-cy="procedures-forms-filledby-select-{{row.model.id}}">
                </app-tdo-enum-select>
              </div>
            </ng-template>
          </tdo-table-column>

          <tdo-table-column displayName="Expire Count" propertyName="FormExpireIn" [rowTemplate]="formExpireIn" *ngIf="
              selectedProcedure?.enumProcedureCategoryID ===
              '00000040-1000-0000-0000-000000000004'
            " data-cy="procedures-forms-expire-count-column">
            <ng-template #formExpireIn let-row>
              <input style="outline: unset; border: 1px solid var(--tdo-primary); width: 80px;"
                [(ngModel)]="row.model.FormExpireIn" (input)="configurationService.setDirty();" data-cy="procedures-forms-expire-count-input-{{row.model.id}}" />
            </ng-template>
          </tdo-table-column>

          <tdo-table-column displayName="Expire Unit" propertyName="enumFormExpireTimeID" [rowTemplate]="expireEnums"
            *ngIf="
              selectedProcedure?.enumProcedureCategoryID ===
              '00000040-1000-0000-0000-000000000004'
            " data-cy="procedures-forms-expire-unit-column">
            <ng-template #expireEnums let-row>
              <div style="height: 25px; width: 80%;" data-cy="procedures-forms-expire-unit-cell-{{row.model.id}}">
                <app-tdo-enum-select name="enumFormExpireTime" [validValueItemId]="row.model.enumFormExpireTimeID"
                  (enumSelected)="row.model.enumFormExpireTimeID = $event.ValidValueItemId; configurationService.setDirty();" data-cy="procedures-forms-expire-unit-select-{{row.model.id}}">
                </app-tdo-enum-select>
              </div>
            </ng-template>
          </tdo-table-column>

          <tdo-table-column displayName="" propertyName="xauditDeleted" [rowTemplate]="actions" data-cy="procedures-forms-actions-column">
            <ng-template #actions let-row>
              <div
                style="padding-left: 20px; cursor: pointer; color: var(--tdo-secondary); text-align: center; position: relative; top: 3px;"
                [matTooltip]="'Delete?'" (click)="onFormDeleteClick(row.model)" data-cy="procedures-forms-delete-{{row.model.id}}">
                <mat-icon>delete</mat-icon>
              </div>
            </ng-template>
          </tdo-table-column>
        </tdo-table>
      </div>
    </div>
  </div>
</div>
